export const MASTER_META_TYPE = {}

export const MASTER_META_KEY = {}

export const G_CAPTCHA_V3_SITE_KEY = "6LdfApIoAAAAABd67AH0JNiIPlwLaHnoArUlonZk";
export const RECAPTCHA_TOKEN_KEY = "RECAPTCHA_TOKEN_KEY";

export const ROLE_KEY = {
  INTERN: 'INTERN',
  MERCHANT: 'MERCHANT',
  SUPERADMIN: 'SUPERADMIN',
  CONTENT_WRITER: 'CONTENT_WRITER',
  MANAGER: 'MANAGER',
  ORDER_CLERKS: 'ORDER_CLERKS',
  STAFF: 'STAFF',
  PRODUCT_MANAGER: 'PRODUCT_MANAGER',
  DELIVERY_DRIVER: 'DELIVERY_DRIVER',
  MARKETING_MANAGER: 'MARKETING_MANAGER',
  BUSINESS_ANALYST: 'BUSINESS_ANALYST',
}

export const STATUS_CONSTANT = {
  active: 'Active',
  archived: 'Archived',
  basic: 'Basic',
  business: 'Business',
  cancel: 'Cancel',
  completed: 'Completed',
  draft: 'Draft',
  delivered: 'Delivered',
  failed: 'Failed',
  free: 'Free',
  inactive: 'Inactive',
  hold: 'Hold',
  paid: 'Paid',
  pending: 'Pending',
  processing: 'Processing',
  published: 'Published',
  unpaid: 'Unpaid',
  unfulfilled: 'Unfulfilled',
  shipping: 'Shipping',
  standard: 'Standard',
  starter: 'Starter',
  premium: 'Premium',
  trial: 'Trial',
  refunded: 'Refunded',
  return: 'Return',
}
